import {triggerModule} from './trigger-module';
import {ELEMENTS_HAVING_DATA_JSOBJ_INCLUDING_LATE_INIT} from './selectors';

export function triggerModules(root, option) {
    triggerModule(root, option);

    root.querySelectorAll(ELEMENTS_HAVING_DATA_JSOBJ_INCLUDING_LATE_INIT).forEach((el) => triggerModule(el, option));
}
